import React, { useState } from "react";

const listData = [
  {
    title: "Since your pain began how has it changed?",
    name: "painBeganHowChanged",
    options: ["Improved", "Worsened", "Stayed the same"],
  },
  {
    title: "Check all of the following that describe your pain",
    name: "describeYourPain",
    options: [
      "Dull/Aching",
      "Stabbing",
      "Hot/Burning",
      "Shooting",
      "Tingling/Prins & Needles",
      "Cramping",
      "Numbness",
      "Throbbing",
      "Squeezing",
      "Tightness",
      "Spasming",
    ],
  },
  {
    title: "When is your pain at its worst?",
    name: "painWrostTime",
    options: ["Morning", "Middle of the night", "Daytime", "Evenings", "Always the same"],
  },
  {
    title: "How often does the pain occur?",
    name: "painOccurs",
    options: [
      "Few times",
      "Every day",
      "Only with activities",
      "Every week/every month",
      "Constantly present but aggravated by activities",
    ],
  },
];

export const PainCharacteristics = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [selectePainCharacteristic, setSelectePainCharacteristic] = useState({
    howItBegan: "",
    decribePain: "",
    painWorst: "",
    painOccur: "",
  });
  const [openIndex, setOpenIndex] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value, e.target.type);

    if (e.target.type === "checkbox") {
      // For checkbox fields, ensure we always work with arrays
      const currentValue = patientMedicationInfo[name];
      // If current value is not an array (e.g., string from old data), initialize as empty array
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      const isChecked = currentArray.includes(value);
      
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: isChecked
          ? currentArray.filter((item) => item !== value) // Remove if already checked (uncheck)
          : [...currentArray, value], // Add if not checked (check)
      });
    } else {
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: value,
      });
    }
  };
  return (
    <>
      <div className="w-full flex justify-start items-center mb-5">
        <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-full p-3 flex flex-col gap-5 bg-white">
          {listData.map((list, index) => (
            <AccordionItem
              key={index}
              index={index}
              title={list.title}
              options={list.options}
              isOpen={openIndex === index}
              onToggle={handleToggle}
              name={list.name}
              selectePainCharacteristic={selectePainCharacteristic}
              handleOnChange={handleOnChange}
              patientMedicationInfo={patientMedicationInfo}
            />
          ))}
        </div>
      </div>
    </>
  );
};

const AccordionItem = ({
  title,
  options,
  isOpen,
  index,
  onToggle,
  name,
  selectePainCharacteristic,
  handleOnChange,
  patientMedicationInfo,
}) => {
  return (
    <>
      <div className="bg-transparent">
        <button
          style={{
            background: isOpen ? "#24518B" : "transparent",
            color: isOpen ? "#fff" : "#0C0544",
          }}
          className={`flex flex-col justify-start items-start w-full gap-4 py-4 border-b border-[#d4d4d4] ${
            isOpen ? "px-8 rounded-full border-b-0" : "px-4 rounded-none "
          } text-left  focus:outline-none  transition-all duration-300 ease-linear`}
          onClick={() => onToggle(index)}
        >
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-[700] font-mainFont 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.2vw] ${
                isOpen ? "text-[#fff]" : "text-[#333333]"
              }`}
            >
              {title}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`w-5 h-5 transition-transform duration-500 ${
                isOpen ? "transform rotate-180 " : ""
              }`}
            >
              <path
                d="M13.9999 3.33326L1.99994 3.33326C1.87845 3.33364 1.75936 3.36715 1.65549 3.43018C1.55163 3.49321 1.46692 3.58337 1.41048 3.69097C1.35404 3.79856 1.32802 3.9195 1.33521 4.04079C1.3424 4.16207 1.38253 4.27909 1.45128 4.37926L7.45128 13.0459C7.69994 13.4053 8.29861 13.4053 8.54794 13.0459L14.5479 4.37926C14.6174 4.2793 14.6581 4.16222 14.6657 4.04073C14.6733 3.91925 14.6474 3.79801 14.5909 3.69019C14.5344 3.58237 14.4495 3.49209 14.3453 3.42917C14.2411 3.36624 14.1217 3.33307 13.9999 3.33326Z"
                fill={isOpen ? "white" : "#0A1E44"}
              />
            </svg>
          </div>
        </button>
        <div
          className={`overflow-hidden transition-all duration-500 ease-linear ${
            isOpen ? "max-h-96" : "max-h-0"
          }`}
        >
          <div className="p-6 bg-transparent flex flex-wrap items-center 2xl:gap-4 xl:gap-4 lg:gap-4 md:gap-4 gap-2 ">
            {options.map((cur, id) => (
              <>
                <div
                  key={id}
                  className="flex flex-shrink-0 justify-start items-center gap-3 border border-[#d4d4d4] py-2 px-5 rounded-full"
                >
                  <input
                    name={name}
                    value={
                      cur
                    }
                    type={
                      name === "describeYourPain" || name === "painWrostTime"
                        ? "checkbox"
                        : "radio"
                    }
                    id={`section${index + 1}_${id}`}
                    onChange={handleOnChange}
                    checked={
                      name === "describeYourPain" || name === "painWrostTime"
                        ? Array.isArray(patientMedicationInfo[name])
                          ? patientMedicationInfo[name].includes(cur)
                          : false
                        : patientMedicationInfo[name] === cur
                    }
                  />
                  <label
                    htmlFor={`section${index + 1}_${id}`}
                    className="font-mainFont font-[400] text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]"
                  >
                    {cur}
                  </label>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
